/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignRight = createReactComponent("align-right", "IconAlignRight", [
  ["path", { d: "M4 6l16 0", key: "svg-0" }],
  ["path", { d: "M10 12l10 0", key: "svg-1" }],
  ["path", { d: "M6 18l14 0", key: "svg-2" }]
]);

export { IconAlignRight as default };
//# sourceMappingURL=IconAlignRight.js.map
